document.addEventListener("DOMContentLoaded", function () {
  var sliderSettings = {
    "width-slider": {
      start: 140,
      min: 80,
      max: 180,
      step: 1,
      hiddenSelector: "#width-value",
    },
    "depth-slider": {
      start: 70,
      min: 65,
      max: 80,
      step: 1,
      hiddenSelector: "#depth-value",
    },
  };

  document.querySelectorAll(".js_range").forEach(function (wrap) {
    var sliderEl = wrap.querySelector('[id$="-slider"]');
    var minusBtn = wrap.querySelector(".js-minus");
    var plusBtn = wrap.querySelector(".js-plus");
    var minEl = wrap.querySelector(".bl_range_min");
    var maxEl = wrap.querySelector(".bl_range_max");

    if (!sliderEl) return;

    var setting = sliderSettings[sliderEl.id];
    if (!setting) return;

    // 現在設定を保持
    sliderEl._currentSetting = Object.assign({}, setting);

    noUiSlider.create(sliderEl, {
      start: setting.start,
      step: setting.step,
      connect: [true, false],
      tooltips: true,
      range: {
        min: setting.min,
        max: setting.max,
      },
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Number(value);
        },
      },
    });

    updateSliderDisplay(sliderEl);

    var hiddenInput = document.querySelector(setting.hiddenSelector);

    sliderEl.noUiSlider.on("update", function (values) {
      var value = values[0];

      if (hiddenInput) {
        hiddenInput.value = value;
      }
    });

    if (minusBtn) {
      minusBtn.addEventListener("click", function () {
        var currentSetting = sliderEl._currentSetting;
        var current = Number(sliderEl.noUiSlider.get());
        var next = current - currentSetting.step;

        if (next < currentSetting.min) {
          next = currentSetting.min;
        }

        sliderEl.noUiSlider.set(next);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", function () {
        var currentSetting = sliderEl._currentSetting;
        var current = Number(sliderEl.noUiSlider.get());
        var next = current + currentSetting.step;

        if (next > currentSetting.max) {
          next = currentSetting.max;
        }

        sliderEl.noUiSlider.set(next);
      });
    }
  });
});

function updateSliderDisplay(sliderEl) {
  var wrap = sliderEl.closest(".js_range");
  if (!wrap) return;

  var minEl = wrap.querySelector(".bl_range_min");
  var maxEl = wrap.querySelector(".bl_range_max");
  var setting = sliderEl._currentSetting;

  if (!setting) return;

  if (minEl) {
    minEl.textContent = setting.min + "cm";
  }

  if (maxEl) {
    maxEl.textContent = setting.max + "cm";
  }
}

function updateSliderByVariant(variant) {
  if (!variant) return;

  updateSingleSlider("width-slider", {
    min: Number(variant.width_min),
    max: Number(variant.width_max),
    step: variant.width_step ? Number(variant.width_step) : 1,
    target: "width",
  });

  updateSingleSlider("depth-slider", {
    min: Number(variant.depth_min),
    max: Number(variant.depth_max),
    step: variant.depth_step ? Number(variant.depth_step) : 1,
    target: "depth",
  });
}

function updateSingleSlider(sliderId, newSetting) {
  var slider = document.getElementById(sliderId);
  if (!slider || !slider.noUiSlider) return;

  var min = newSetting.min;
  var max = newSetting.max;
  var step = newSetting.step || 1;
  var target = newSetting.target;

  if (Number.isNaN(min) || Number.isNaN(max)) return;

  slider._currentSetting = Object.assign({}, slider._currentSetting, {
    min: min,
    max: max,
    step: step,
  });

  slider.noUiSlider.updateOptions({
    step: step,
    range: {
      min: min,
      max: max,
    },
  });

  updateSliderDisplay(slider);
  if(target == "width"){
    slider.noUiSlider.set(140);
  }else{
    slider.noUiSlider.set(60);
  }
}

document.addEventListener("change", function (e) {
  if (!e.target.matches('input[name="id"]')) return;

  const variantId = Number(e.target.value);
  const variant = window.variantRangeData.find(function (item) {
    return item.id === variantId;
  });

  if (variant) {
    updateSliderByVariant(variant);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const edgeMediaData = document.querySelector(".js_edgeMediaData");
  if (!edgeMediaData) return;

  document.addEventListener("change", function (e) {
    const input = e.target;
    if (!input.matches('input[type="radio"][data-option-name="面取り加工"]')) return;

    const gallery = document.querySelector("media-gallery");
    if (!gallery || typeof gallery.setActiveMedia !== "function") return;

    const value = input.dataset.optionValue;
    const edgeR2MediaId = edgeMediaData.dataset.edgeR2MediaId;
    const edgeR5MediaId = edgeMediaData.dataset.edgeR5MediaId;
    console.log(value);
    setTimeout(() => {
      if (value === "R2" && edgeR2MediaId) {
        console.log(edgeR2MediaId);
        gallery.setActiveMedia(edgeR2MediaId, false);
        return;
      }

      if (value === "R5" && edgeR5MediaId) {
        gallery.setActiveMedia(edgeR5MediaId, false);
        return;
      }
    }, 2000);
  });
});
